import { Box, Heading, Text } from '@chakra-ui/react';
import { IRecordedInterviewEntry } from 'api-paths-cas';
import RecordedInterviewAverageScoresSection from '../../../../molecules/RecordedInterviewAverageScoresSection';
import RecordedInterviewDescisionSegment from '../../../../molecules/RecordedInterviewDescisionSegment';

interface IProps {
  interview: IRecordedInterviewEntry;
  isAdmin?: boolean;
}
export default function InterviewAssessmentResults({ interview, isAdmin = false }: IProps) {
  const { userAssessment } = interview;

  const { assessmentNote = '', assessmentDecision, assessedBy = '' } = userAssessment ?? {};

  const showNotes = (assessmentNote?.trim()?.length ?? 0) > 0;

  return (
    <Box lineHeight={1} fontSize="sm">
      <RecordedInterviewAverageScoresSection
        interview={interview}
        headingSize="xs"
        gridProps={{ columns: { base: 3, '2xl': 6 } }}
      />

      {showNotes && (
        <>
          <Heading as="h3" fontSize="xs" fontWeight="medium" mt="4" mb="2">
            Assessors notes
          </Heading>

          <Text>{assessmentNote}</Text>
        </>
      )}

      <RecordedInterviewDescisionSegment descision={assessmentDecision} labelSize="xs" />

      {isAdmin && (
        <>
          <Heading as="h3" fontSize="xs" fontWeight="medium" mb="2">
            Assessed by
          </Heading>

          <Text>{assessedBy}</Text>
        </>
      )}
    </Box>
  );
}
